import React from 'react'
import { VStack, Heading, Text } from '@chakra-ui/react'
import type { BoxProps } from '@chakra-ui/react'
import { SectionContainer } from '@/components/SectionContainer'
import { useTranslation } from 'react-i18next'

export const HeroSection = (props: BoxProps) => {
  const { t } = useTranslation()
  return (
    <SectionContainer containerStyle={props}>
      <VStack spacing={2} alignItems={'flex-start'}>
        <Heading as="h1" variant={'h1'}>
          {t('homepage.title')}
        </Heading>
        <Text textStyle={'bodySecondary'} color={'#565F76'}>
          {t('homepage.subtitle')}
        </Text>
      </VStack>
    </SectionContainer>
  )
}
